import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ef8265b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }
const _hoisted_2 = { class: "list-title" }
const _hoisted_3 = { class: "s-title" }

import { ref, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getValidators, getChain } from "@/api/_common";
import Title from "@/components/SecondaryTitle.vue";
import List from "@/components/List.vue";
import Summary from "./summary.vue";
import Graph from "./graph.vue";
import { useMq } from "vue3-mq";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const pageSize = 10;
const rowData = [
  {
    prop: "Rank",
    label: "validatorlist.rank",
    method: (row) => row.Rank,
  },
  {
    prop: "Address",
    label: "validatorlist.address",
    method: (row) =>
      isMdOrSmOrXs
        ? `${row.Address.substr(0, 8)}...${row.Address.substr(34, 8)}`
        : row.Address,
  },
  {
    prop: "StakeAmount",
    label: "validatorlist.amount",
    method: (row) => row.StakeAmount,
  },
  {
    prop: "Percentage",
    label: "validatorlist.percent",
    method: (row) => row.Percent,
  },
];

const route = useRoute();
const router = useRouter();

const chainInfo = ref({
  Height: 0,
  BlockTime: 0,
});
const validators = ref({
  ValidatorInfos: [],
  TotalCount: 0,
});

onMounted(async () => {
  if (!route.query.page) {
    await router.replace({
      query: {
        page: 1,
      },
    });
  }
  await init();
});

const isMdOrSmOrXs = computed(() => {
  const mq = useMq();
  return mq.current === "md" || mq.current === "sm" || mq.current === "xs";
});
const currentPage = computed(() => Number(route.query.page));

const init = async () => {
  await getChainInfo();
  await getValidatorsList();
};
const getChainInfo = async () => {
  const res = await getChain();
  chainInfo.value = res;
};
const getValidatorsList = async () => {
  const res = await getValidators({
    PageNo: currentPage.value - 1,
    PageSize: pageSize,
  }).catch(() => console.error("Error fetching validators"));
  if (res) {
    validators.value = res;
    if (validators.value.ValidatorInfos) {
      for (let i = 0; i < pageSize; i++) {
        validators.value.ValidatorInfos[i].Rank =
          pageSize * (currentPage.value - 1) + i + 1;
      }
    }
  }
};
const handlePageChange = async (newPage) => {
  await router.replace({
    query: {
      page: newPage,
    },
  });
  await getValidatorsList();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Title, {
        title: _ctx.$t('validatorlist.name')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("home.overview")), 1),
    _createVNode(Summary, {
      height: chainInfo.value.Height,
      validator: validators.value.TotalCount,
      time: chainInfo.value.BlockTime
    }, null, 8, ["height", "validator", "time"]),
    (validators.value.TotalCount > 0)
      ? (_openBlock(), _createBlock(List, {
          key: 0,
          data: validators.value.ValidatorInfos,
          handleCurrentChange: handlePageChange,
          rowDatas: rowData,
          total: validators.value.TotalCount,
          firstColumnWidth: "180",
          secondColumnWidth: "450",
          addressColumn: "1",
          "current-page": _unref(currentPage)
        }, null, 8, ["data", "total", "current-page"]))
      : _createCommentVNode("", true),
    (validators.value.TotalCount > 0)
      ? (_openBlock(), _createBlock(Graph, {
          key: 1,
          validators: validators.value,
          pageSize: pageSize
        }, null, 8, ["validators"]))
      : _createCommentVNode("", true)
  ]))
}
}

})